import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import { pageMenuTabList01 } from 'types/common';
import { fnToggleIntroduction } from 'assets/js/commonUtil';

import 'assets/css/company.scss';

export default function Introduction() {
  const {id} = useParams<{id: string}>();
  
  pageMenuTabList01[0].on = true;

  useEffect(() => {
    fnToggleIntroduction();
  }, []);

  return (
    <div className="page_content introduction">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/company-hero_1920x1080.jpg.jpg" imgText="42년 오직 한 길만" textcolor="#333"></TopImage>
      <PageTab props={pageMenuTabList01}></PageTab>
      <div className="container">
        <div className="container-title">
          42년 업력과 전문화된 생산시설,<br/>
          온·오프라인 유통채널을 갖춘<br/>
          <span className="highlight">헬스케어 전문기업</span>입니다.          
        </div>
        <div className="introduction-img">
          <div className="img-effect active">
            <img className="img-style" src="https://img.chunhomall.com/images/brand_site/company-section-nature_600x600.jpg.jpg" alt=""/>
            <div className="txt-effect">
              <div className="img-logo">
                <img src="https://img.chunhomall.com/images/brand_site/company-section-logo_40x40.png.png" alt=""/>ATURE
              </div>
              <div className="txt">
                하늘 아래 가장 좋은<br/>
                원료를 담는<br/>
                <span className="highlight">자연 기업</span>
              </div>
            </div>
          </div>
          <div className="img-effect">
            <img className="img-style" src="https://img.chunhomall.com/images/brand_site/company-section-nutrition_600x600.jpg.jpg" alt=""/>
            <div className="txt-effect">
              <div className="img-logo">
                <img src="https://img.chunhomall.com/images/brand_site/company-section-logo_40x40.png.png" alt=""/>UTRITION
              </div>
              <div className="txt">
                하늘 아래 가장 좋은<br/>
                영양을 드리는<br/>
                <span className="highlight">건강 기업</span>
              </div>
            </div>
          </div>
          <div className="img-effect">
            <img className="img-style" src="https://img.chunhomall.com/images/brand_site/company-section-next_600x600.jpg.jpg" alt=""/>
            <div className="txt-effect">
            <div className="img-logo">
                <img src="https://img.chunhomall.com/images/brand_site/company-section-logo_40x40.png.png" alt=""/>EXT
              </div>
              <div className="txt">
                하늘 아래 가장 좋은<br/>
                내일을 드리는<br/>
                <span className="highlight">라이프케어 기업</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="container-title">
          <span className="highlight">자연</span>에서 얻은 좋은 원료의 <span className="highlight">영양</span>을 그대로 담아<br/>
          더나은 <span className="highlight">내일</span>을 선물합니다.<br/>
        </div>
      </div>
    </div>
  );
}
